<!--  -->
<template>
  <div>

    <div
      id="popup"
      v-bind:class="{'ol-popup':true,'ol-popup-maprightbutton':ucSetting.isMapRightButton}"
    >
      <a
        href="#"
        id="popup-closer"
        class="ol-popup-closer"
      ></a>
      <div id="popup-content">

      </div>
    </div>

    <BusSegmentEndOverlay
      v-show="false"
      ref="ucBusSegmentEnd"
    ></BusSegmentEndOverlay>

    <POISurroundOverLay
      v-show="false"
      ref="ucpoiSurround"
    ></POISurroundOverLay>

    <DrawGeometryOverlay
      v-show="false"
      ref="ucDrawGeometry"
    ></DrawGeometryOverlay>

    <DrawPolycurveOverlay
      v-show="false"
      ref="ucDrawPolycurve"
    >
    </DrawPolycurveOverlay>

    <MapRightHandButtonOverlay 
      v-show="false" 
      ref="ucMapRightButton">
    </MapRightHandButtonOverlay>


    <UCFormSelectCollectFolder ref="ucFormCollectFolder"></UCFormSelectCollectFolder>

  </div>
</template>

<script>
import { LayerFeatureType } from "./layer/LayerFeatureType";
import { RouteLayer } from "./layer/RouteLayer";
import { DrawGeometryLayer } from "./layer/DrawGeometryLayer";

import BusSegmentEndOverlay from "./UCOverlay/BusSegmentEndOverlay.vue";
import POISurroundOverLay from "./UCOverlay/POISurroundOverLay.vue";
import DrawGeometryOverlay from "./UCOverlay/DrawGeometryOverlay.vue";
import DrawPolycurveOverlay from "./UCOverlay/DrawPolycurveOverlay.vue";
import UCFormSelectCollectFolder from "./UCOverlay/UCFormSelectCollectFolder.vue";
import MapRightHandButtonOverlay from "./UCOverlay/MapRightHandButtonOverlay.vue";

import { POISearchLayer } from "./layer/POISearchLayer";
import { POISurroundOverLayJs } from "./UCOverlay/POISurroundOverLayJs.js";
import { DrawGeometryOverlayJs } from "./UCOverlay/DrawGeometryOverlayJs.js";
import { DrawPolycurveOverlayJs } from "./UCOverlay/DrawPolycurveOverlayJs.js";
import { MapRightHandButtonOverlayJs } from "./UCOverlay/MapRightHandButtonOverlayJs.js";

export default {
  name: "UCMapOverlay",
  data() {
    return {
      ucSetting: {
        isMapRightButton: false
      },

      curMap: null,

      //当前地图弹窗
      currentMapOverlay: null,

      //地图弹窗内容
      mapOverlayContent: null,

      //周边查询
      poiSurroundOverlayJs: new POISurroundOverLayJs(),

      //绘制几何形状
      drawGeometryOverlayJs: new DrawGeometryOverlayJs(),

      drawPolycurveOverlayJs: new DrawPolycurveOverlayJs(),

      //地图右键
      mapRightButtonJs: new MapRightHandButtonOverlayJs()
    };
  },

  components: {
    BusSegmentEndOverlay,
    POISurroundOverLay,
    DrawGeometryOverlay,
    DrawPolycurveOverlay,

    UCFormSelectCollectFolder,

    MapRightHandButtonOverlay
  },

  computed: {},

  mounted() {
    // let hello= new Hello().$mount();
    // let uc=new BusSegmentEndOverlay().$mount();
  },

  methods: {
    init() {
      
      

      this.mapOverlayContent = document.getElementById("popup-content");

      let container = document.getElementById("popup");
      
      //初始化事件
      this._initEvents();

      //新建overlay
      this.currentMapOverlay = new ol.Overlay({
        //设置弹出框的容器
        element: container,
        //是否自动平移，即假如标记在屏幕边缘，弹出时自动平移地图使弹出框完全可见
        autoPan: true
      });

      
      

      this.poiSurroundOverlayJs.ucOverLay = this.$refs.ucpoiSurround;
      this.poiSurroundOverlayJs.ucFormCollectFolder =
        this.$refs.ucFormCollectFolder;

      this.drawGeometryOverlayJs.ucOverLay = this.$refs.ucDrawGeometry;

      this.drawPolycurveOverlayJs.ucOverLay = this.$refs.ucDrawPolycurve;
      this.drawPolycurveOverlayJs.ucFormCollectFolder =
        this.$refs.ucFormCollectFolder;

      this.mapRightButtonJs.ucOverLay = this.$refs.ucMapRightButton;

    },

    showOverlay(position, feature) {

      //设置界面
      this.ucSetting.isMapRightButton = false;

      let self = this;
      let isOverlay = feature.get(
        LayerFeatureType.field_name_featureTypeIsOverlay
      );
      if (!isOverlay) return;

      let featureType = feature.get(LayerFeatureType.field_name_featureType);

      if (
        featureType === LayerFeatureType.routelayer_bus_focusedBusSegmentEnd ||
        featureType === LayerFeatureType.routelayer_bus_busSegmentEnd
      ) {
        this.$refs.ucBusSegmentEnd.segmentItem = feature.get(
          RouteLayer.field_bindingObject
        );
        this.$refs.ucBusSegmentEnd.init();
        //渲染完成后，执行该方法
        this.$refs.ucBusSegmentEnd.$nextTick(function() {
          let innerHtml = self.$refs.ucBusSegmentEnd.$el.innerHTML;
          self.mapOverlayContent.innerHTML = innerHtml;
          //设置overlay的显示位置
          self.currentMapOverlay.setPosition(position);

          self.clearOverlays();
          self.curMap.addOverlay(self.currentMapOverlay, true);
          self.curMap.getView().setCenter(position);
        });
      } else if (featureType === LayerFeatureType.poisearchlayer_marker) {
        let curPOI = feature.get(POISearchLayer.field_bindingObject);

        self.poiSurroundOverlayJs.curPOI = curPOI;

        self.poiSurroundOverlayJs.init();

        self.poiSurroundOverlayJs.ucRenderFinished(function(innerHtml) {
          self.mapOverlayContent.innerHTML = innerHtml;
          //设置overlay的显示位置
          self.currentMapOverlay.setPosition(position);

          self.clearOverlays();
          self.curMap.addOverlay(self.currentMapOverlay, true);
          // self.curMap.getView().setCenter(position);

          self.poiSurroundOverlayJs.bindingEvents();
        });
      } else if (
        featureType === LayerFeatureType.drawLayer_marker ||
        featureType === LayerFeatureType.drawLayer_polyline ||
        featureType === LayerFeatureType.drawLayer_polygon
      ) {
        self.drawGeometryOverlayJs.drawItem = feature.get(
          DrawGeometryLayer.field_bindingObject
        );

        self.drawGeometryOverlayJs.init();

        self.drawGeometryOverlayJs.ucRenderFinished(function(innerHtml) {
          self.mapOverlayContent.innerHTML = innerHtml;
          //设置overlay的显示位置
          self.currentMapOverlay.setPosition(position);

          self.clearOverlays();
          self.curMap.addOverlay(self.currentMapOverlay, true);

          self.drawGeometryOverlayJs.bindingEvents();
        });
      } else if (
        featureType === LayerFeatureType.drawLayer_savedPolyline ||
        featureType === LayerFeatureType.drawLayer_savedPolygon
      ) {
        self.drawPolycurveOverlayJs.drawItem = feature.get(
          DrawGeometryLayer.field_bindingObject
        );

        self.drawPolycurveOverlayJs.init();

        self.drawPolycurveOverlayJs.ucRenderFinished(function(innerHtml) {
          self.mapOverlayContent.innerHTML = innerHtml;
          //设置overlay的显示位置
          self.currentMapOverlay.setPosition(position);

          self.clearOverlays();
          self.curMap.addOverlay(self.currentMapOverlay, true);
          self.curMap.getView().setCenter(position);

          self.drawPolycurveOverlayJs.bindingEvents();
        });
      } else if (featureType === LayerFeatureType.map_right_hand_button) {
        this.ucSetting.isMapRightButton = true;


        let mapInfo = feature.get("bindingObject");
        self.mapRightButtonJs.mapInfo=mapInfo;
        self.mapRightButtonJs.init();

        self.mapRightButtonJs.ucRenderFinished(function(innerHtml) {
          self.mapOverlayContent.innerHTML = innerHtml;
          //设置overlay的显示位置
          self.currentMapOverlay.setPosition(position);

          //不清除，保留原有overlays
          // self.clearOverlays();
          self.curMap.addOverlay(self.currentMapOverlay, true);

          self.mapRightButtonJs.bindingEvents();
        });
      }
    },

    hideOverlay() {
      this.currentMapOverlay.setPosition(undefined);
    },

    /**
     * 清除地图所有overlays
     */
    clearOverlays() {
      let overlayCollections = this.curMap.getOverlays();
      let overlays = new Array();
      if (overlayCollections) {
        overlays = overlayCollections.getArray();
      }

      let tempOverlay = null;
      for (let tempIndex = 0; tempIndex < overlays.length; tempIndex++) {
        tempOverlay = overlays[tempIndex];
        this.curMap.removeOverlay(tempOverlay);
        tempIndex = tempIndex - 1;
      }
    },

    on_getSurroundInfoFinished(callback) {
      if (callback) {
        if (this.poiSurroundOverlayJs) {
          this.poiSurroundOverlayJs.on_getSurroundInfoFinished(callback);
        }
      }
    },

    /**
     * 订阅保存绘制几何形状
     */
    on_saveDrawGeometry(callback) {
      if (callback) {
        if (this.drawGeometryOverlayJs) {
          this.drawGeometryOverlayJs.on_saveDrawGeometry(callback);
        }
      }
    },

    /**
     * 订阅删除绘制几何形状
     */
    on_deleteDrawGeometry(callback) {
      if (callback) {
        if (this.drawGeometryOverlayJs) {
          this.drawGeometryOverlayJs.on_deleteDrawGeometry(callback);
        }
      }
    },

    on_selectCollectFolderFinished(callback) {
      if (callback) {
        if (this.drawGeometryOverlayJs) {
          this.drawPolycurveOverlayJs.on_selectCollectFolderFinished(callback);
        }
      }
    },



    on_mapRightButton_getPOIInfoFinished(callback) {
      if (callback) {
        if (this.mapRightButtonJs) {
          this.mapRightButtonJs.on_getPOIInfoFinished(callback);
        }
      }
    },

    _initEvents()
    { 
      let self = this;
      let popupCloser = document.getElementById("popup-closer");
      popupCloser.addEventListener("click", function() {
        self.currentMapOverlay.setPosition(undefined);
      });

    }

  }
};
</script>


<style lang="scss" scoped>
.ol-popup {
  position: absolute;
  background-color: white;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
  z-index: 20;
}

.ol-popup-maprightbutton {
  min-width: 120px;
  width: 120px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: white;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "✖";
}
</style>